import React from "react";
import { Typography, Button } from "@material-ui/core";
import SelectBoolean from "../../components/Frequents/SelectBoolean";
import TextEditor from "../../components/Frequents/TextEditor";

export default props => (
    <div style={{ padding: "20px" }}>
        <Typography variant="body1">Ønsker du at modtage en mail, når en klient har booket online?</Typography>
        <SelectBoolean
            name="confirmationMail"
            text="Bekræftelses mail"
            prop={props.propBM}
            choice1="Ja"
            choice2="Nej"
            value1={true}
            value2={false}
            changeValue={props.changeBM}
        />
        <div style={{ height: "20px" }} />
        <Typography variant="body1">
            Her kan du tilføje ekstra tekst til den bekræftelsesmail, klienterne modtager:
        </Typography>
        <div style={{ height: "10px" }} />
        <TextEditor value={props.propBMT} onChange={props.changeBMT} />
        <div style={{ height: "20px" }} />
        <Button
            style={{ float: "right", color: "#fff" }}
            color="primary"
            variant="contained"
            onClick={() => props.saveBMT()}>
            Gem Indstilling
        </Button>
    </div>
);
